exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mobile-search[data-v-84c616b4] {\n  position: relative;\n  width: 64px;\n  height: 64px;\n}\n.mobile-search .search-icon[data-v-84c616b4] {\n  content: url(\"/svg/search-dark.svg\");\n  width: 20px;\n  height: 18px;\n  display: block;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  transition: transform 0.15s;\n}\n.mobile-search .search-icon.active[data-v-84c616b4] {\n  content: url(\"/svg/close.svg\") !important;\n  color: #fff !important;\n}", ""]);

// exports
